import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import config from 'constants/config'
import fetchBusinessEmployees from 'actions/businessTraveller/fetchBusinessEmployees'
import fetchMyApprovalQueue from 'actions/businessTraveller/fetchMyApprovalQueue'

interface Params {
  currentRegionCode: string,
  isEnabled?: boolean,
}

function useBusinessTravellerPendingApprovalsFetcher(params: Params) {
  const { currentRegionCode, isEnabled = true } = params

  const appDispatch = useAppDispatch()
  const businessId = useAppSelector(state => state.businessTraveller.currentBusinessAccount?.business?.id)
  const employeeId = useAppSelector(state => state.businessTraveller.currentBusinessAccount?.employee?.id)
  const approvalRequestsApprovals = useAppSelector(state => state.businessTraveller.approvalRequestsApprovals)
  const employees = useAppSelector(state => state.businessTraveller.employees.all)

  useEffect(() => {
    if (config.businessTraveller.currentAccountMode === 'business' && isEnabled && businessId) {
      appDispatch(fetchBusinessEmployees(businessId))
    }
  }, [appDispatch, businessId, isEnabled])

  useEffect(() => {
    if (config.businessTraveller.currentAccountMode === 'business' && isEnabled && businessId && currentRegionCode && employeeId && employees) {
      const employeesArray: Array<App.BusinessTraveller.EmployeeFromMeEndpoint> = Object.values(employees)
      appDispatch(fetchMyApprovalQueue(businessId, employeeId, currentRegionCode, employeesArray))
    }
  }, [appDispatch, businessId, employeeId, currentRegionCode, employees, isEnabled])

  return {
    approvalRequests: approvalRequestsApprovals?.request,
    status: approvalRequestsApprovals?.status,
  }
}

export default useBusinessTravellerPendingApprovalsFetcher
